import React, {useState} from "react";
import {Card, Col, Form, Input, Modal, Row, Image, Upload, Select} from "antd";
import {askGPT} from "../service/api/userAPI";
import { Radio } from 'antd';
import JsonViewer from "../component/JsonViewer";
import {EditFilled, PlusOutlined, ToolFilled} from "@ant-design/icons";
import ReactMarkdown from 'react-markdown';
import CountryLocation from "../badge/countryLocation";
const GptTestPromptModal = ({buttonName, title, prompt, callback}) => {
    const [open, setOpen] = useState(false);
    const [lan, setLan] = useState("CN");
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState("");
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([])
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
    const showModal = () => {
        setOpen(true)
    }
    const handleTest = () => {
        form.submit();  // This will trigger form submission
    };
    const onFinish = (values) => {
        console.log('Form Submitted with values:', values);
        setLoading(true)
        if(fileList.length > 0) {
            let file = fileList[0]
            if (!file.url && !file.preview) {
                file.preview = getBase64(file.originFileObj);
            }
            file.preview.then(result => {
                values["attachment"] = result;
                askGPT(prompt.id, values, lan).then(
                    res => {
                        setResult(res.data)
                    }
                ).finally(() => {
                    setLoading(false)
                })
            })
        } else {
            askGPT(prompt.id, values, lan).then(
                res => {
                    setResult(res.data)
                }
            ).finally(() => {
                setLoading(false)
            })
        }
    }
    const extractPlaceHolder = (sentence) => {
        const regex = /\$\{(\w+)\}/g;
        const placeholders = new Set();
        let match;
        while ((match = regex.exec(sentence)) !== null) {
            placeholders.add(match[1]);
        }
        return Array.from(placeholders);
    };

    const PlaceholderForm = ({ sentence }) => {
        const placeholders = extractPlaceHolder(sentence);
        return (
            <Form
            form={form}
            name="placeholder-form"
            onFinish={onFinish}>
                {placeholders.map((placeholder) => (
                    <Form.Item key={placeholder} name={placeholder} label={placeholder} rules={[{required:true}]}>
                        <Input/>
                    </Form.Item>
                ))}
            </Form>
        );
    };
    const getBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };
    const customUploadFile = (file) => {

    }
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );

    const getPromptByLan = (language) => {
        if (language === "CN")    return prompt.promptChinese;
        if (language === "JA")    return prompt.promptJapanese;
        if (language === "KO")    return prompt.promptKorean;
        if (language === "ES")    return prompt.promptSpanish;
        if (language === "PT")    return prompt.promptPortuguese;
        if (language === "ZH_TW") return prompt.promptChineseTaiwan;
        if (language === "ZH_HK") return prompt.promptCantonese;
        if (language === "HI")    return prompt.promptHindi;
        if (language === "AR")    return prompt.promptArabic;
        if (language === "FR")    return prompt.promptFrench;
        if (language === "RU")    return prompt.promptRussian;
        // default/fallback
        return prompt.promptEnglish;
    };

    return (
        <>
            <a onClick={showModal} style={{display: 'flex', alignItems: 'center'}}>
                <ToolFilled style={{marginRight: 8}}/> {/* Adjust margin as needed */}
                {buttonName}
            </a>
            <Modal
                title={title}
                centered
                open={open}
                onOk={handleTest}
                okText={"Test"}
                onCancel={() => setOpen(false)}
                aria-hidden={!open}
                width={1000}
            >
                <Card>
                    <Row gutter={16}>
                        <Col span={12}>
                            <PlaceholderForm sentence={lan === "CN" ? prompt.promptChinese : prompt.promptEnglish}/>
                            <Select
                                value={lan}
                                onSelect={(e) => setLan(e)}
                                style={{ width: '100%' }}
                            >
                                <Select.Option value="EN" >
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="GB" style={{ marginRight: 8 }} /> English</span>
                                </Select.Option>

                                <Select.Option value="CN" >
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="CN" style={{ marginRight: 8 }} /> Chinese</span>
                                </Select.Option>

                                <Select.Option value="JA" >
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="JP" style={{ marginRight: 8 }} /> Japanese</span>
                                </Select.Option>

                                <Select.Option value="ZH_HK">
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="HK" style={{ marginRight: 8 }} /> Cantonese</span>
                                </Select.Option>

                                <Select.Option value="ZH_TW">
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="TW" style={{ marginRight: 8 }} /> Traditional Chinese (Taiwan)</span>
                                </Select.Option>

                                <Select.Option value="FR">
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="FR" style={{ marginRight: 8 }} /> French</span>
                                </Select.Option>

                                <Select.Option value="HI">
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="IN" style={{ marginRight: 8 }} /> Hindi</span>
                                </Select.Option>

                                <Select.Option value="ES">
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="ES" style={{ marginRight: 8 }} /> Spanish</span>
                                </Select.Option>

                                <Select.Option value="PT">
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="PT" style={{ marginRight: 8 }} /> Portuguese</span>
                                </Select.Option>

                                <Select.Option value="AR">
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="SA" style={{ marginRight: 8 }} /> Arabic</span>
                                </Select.Option>

                                <Select.Option value="RU">
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="RU" style={{ marginRight: 8 }} /> Russian</span>
                                </Select.Option>

                                <Select.Option value="KO">
                                    <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="KR" style={{ marginRight: 8 }} /> Korean</span>
                                </Select.Option>
                            </Select>
                            <Card style={{marginBottom: "8px"}}>
                                {getPromptByLan(lan)}
                            </Card>
                            <Upload
                                customRequest={({ file, onSuccess }) => {
                                    onSuccess("Upload successful");
                                }}
                                listType="picture-card"
                                fileList={fileList}
                                onPreview={handlePreview}
                                onChange={handleChange}
                            >
                                {fileList.length >= 1 ? null : uploadButton}
                            </Upload>
                        </Col>

                        <Col span={12}>
                            {prompt.jsonMode?<JsonViewer jsonString={JSON.stringify(result)} loading={loading}/>:
                                <Card loading={loading}><ReactMarkdown>{result}</ReactMarkdown></Card>}
                        </Col>
                    </Row>
                </Card>
                {previewImage && (
                    <Image
                        wrapperStyle={{
                            display: 'none',
                        }}
                        preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) => setPreviewOpen(visible),
                            afterOpenChange: (visible) => !visible && setPreviewImage(''),
                        }}
                        src={previewImage}
                    />
                )}
            </Modal>
        </>
    )
}
export default GptTestPromptModal